<template>
  <div>
    <bfheader></bfheader>
    <div class="main-content mt-2">
      <div class="header">
        <b-alert variant="info" :show="message != null">{{message}}</b-alert>
        <b-alert variant="danger" :show="error != null">{{error}}</b-alert>
      </div>
      <b-container fluid>
        <div class="p-2 border-bottom border-info">
          <h4 class="text-info font-italic">
            <strong>測定結果一覧</strong>
            <span class="ml-2"><button class="btn btn-info" @click="loadItems"><i class="fas fa-sync"/> 再読込</button></span>
            <span class="ml-2"><button class="btn btn-info" @click="download"><i class="fas fa-download"/> ダウンロード</button></span>
          </h4>
        </div>
        <b-row class="my-1">
          <b-col sm="2"><label for="input-small">日付:</label></b-col>
          <b-col sm="5">
            <b-form-input type="date" v-model="filter.date" @change="loadItems"></b-form-input>
          </b-col>
        </b-row>
        <div>
          <v-client-table :columns="table.columns" :data="dailyEnquetes" :options="table.options" class="users-table">
            <a slot="user_id" slot-scope="props">
              <b-btn variant="link" size="sm" @click="showDetailModal(props.row)">
                <b>{{props.row.user_id}}</b>
              </b-btn>
            </a>
            <a slot="calendarTime" slot-scope="props">
              <b>{{formatDate(props.row.calendarTime)}}</b>
            </a>
            <a slot="weightInGrams" slot-scope="props">
              <b>{{vv1000(props.row, 'weightInGrams')}}</b>
            </a>
            <a slot="lastModifiedAt" slot-scope="props">
              <b>{{formatDateTime(props.row.lastModifiedAt)}}</b>
            </a>
          </v-client-table>
        </div>
      </b-container>
    </div>

    <bffooter></bffooter>
    <div>
      <b-modal ref="userDetailModal" centered title="詳細"
        header-bg-variant="info"
        header-text-variant="light"
        hide-footer>
        <div>
          <p class="my-4">
            <span>{{currentDailyEnquete}}</span>
          </p>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Logger } from 'aws-amplify'
import moment from 'moment-timezone'
import NumberUtils from '@/utils/NumberUtils'

import { ClientTable } from 'vue-tables-2'

import bfheader from '@/components/BfHeader'
import bffooter from '@/components/BfFooter'

const logger = new Logger('userDailyEnquetes')
Vue.use(ClientTable)

/*
user_id (S) ap-northeast-1:04db4d3e-2f1b-4277-8655-37d56d10bac6
calendarTime (S)  2.01809E+16
answerTimeInSeconds (S) 1537331074
bloodPressureDiastolic (NULL) TRUE
bloodPressureSystolic (NULL)  TRUE
bodyTemperature (NULL)  TRUE
boneDensity (NULL)  TRUE
calendarDate (S)  2018/9/19
chill (N) 1
cough (N) 1
dateTimeInSeconds (S) 1537369199
diagnosis (NULL)  TRUE
doctor (BOOL) FALSE
drink (N) 1
eventCircle (BOOL)  FALSE
eventInjured (BOOL) FALSE
eventOthers (NULL)  TRUE
eventParty (BOOL) FALSE
eventTrip (BOOL)  FALSE
feelings (N)  1
joint (N) 1
lastModifiedAt (S)  1.53733E+12
malaise (N) 1
medicine (BOOL) FALSE
medicineDesc (NULL) TRUE
muscle (N)  1
nose (N)  1
outgoing (N)  1
pulseRate (NULL)  TRUE
regular (BOOL)  TRUE
sleep (N) 1
startTimeInSeconds (S)  1537369199
summaryId (S) dailyEnquetes-1537369199999
throat (N)  1
type (S)  dailyEnquetes
vitalCondition (N)  1
weightInKilograms (NULL)  TRUE
*/

export default {
  name: 'userDailyEnquetes',
  components: {
    bfheader,
    bffooter
  },
  data () {
    return {
      loading: false,
      message: null,
      error: null,
      filter: {
        date: moment().format('YYYY-MM-DD')
      },
      dailyEnquetes: [],
      currentDailyEnquete: {},
      table: {
        columns: [
          'user_id', 'userNo', 'userGroup.name', 'calendarDate',
          'age',
          'weightInGrams', 'bloodPressureDiastolic', 'bloodPressureSystolic', 'bloodPulse', 'bodyTemperature',
          'boneDensity', 'boneDensityParcent', 'bloodVesselAge', 'lastModifiedAt'
        ],
        options: {
          headings: {
            user_id: '会員番号',
            userNo: 'ID番号',
            'userGroup.name': '参加測定会',
            'calendarDate': '日付',
            groupName: '参加測定会',
            calendarTime: '日付',
            age: '年齢',
            weightInGrams: '体重',
            bloodPressureDiastolic: '最高血圧',
            bloodPressureSystolic: '最低血圧',
            bloodPulse: '脈拍',
            bodyTemperature: '体温',
            boneDensity: '骨量判定',
            boneDensityParcent: '骨量対最大(%)',
            bloodVesselAge: '血管年齢(dV)',
            lastModifiedAt: '測定日時'
          },
          sortable: [ 'user_id', 'userNo', 'calendarTime' ],
          filterable: [ 'user_id', 'calendarTime' ],
          texts: {
            filterPlaceholder: '検索する'
          },
          sortIcon: {
            base: 'fas', up: 'fa-arrow-up', down: 'fa-arrow-down', is: 'fa-sort'
          },
          orderBy: {
            column: 'user_id',
            ascending: true
          }
        },
        customFilters: ['calendarTime'],
        csv: {
          headings: {
            'user_id': '会員番号',
            userNo: 'ID番号',
            'userGroup.name': '参加測定会',
            'calendarDate': '日付',
            age: '年齢',
            weightInGrams: '体重(g)',
            bloodPressureDiastolic: '最高血圧',
            bloodPressureSystolic: '最低血圧',
            bloodPulse: '脈拍',
            bodyTemperature: '体温',
            boneDensity: '骨量判定',
            boneDensityParcent: '骨量対最大(%)',
            bloodVesselAge: '血管年齢(dV)',
            lastModifiedAt: '測定日時',
            'bodyCompositions.measuredBy': '測定機器',
            'bodyCompositions.measuredDate': '測定日時',
            'bodyCompositions.measuredTime': '測定時刻',
            'bodyCompositions.weightAdjustmentInGrams': '風量引き(g)',
            'bodyCompositions.physicalType': '体型',
            'bodyCompositions.age': '年齢',
            'bodyCompositions.gender': '性別',
            'bodyCompositions.heightInMillimeters': '身長(mm)',
            'bodyCompositions.weightInGrams': '体重(g)',
            'bodyCompositions.standardWeightInGrams': '標準体重(g)',
            'bodyCompositions.bodyMassIndex': 'BMI',
            'bodyCompositions.bodyFatMassInGrams': '体脂肪(g)',
            'bodyCompositions.bodyFatFreeMassInGrams': '除体脂肪量(g)',
            'bodyCompositions.bodyFatInPercent': '体脂肪率(%)',
            'bodyCompositions.bodyWaterMassInGrams': '体水分量(g)',
            'bodyCompositions.basalMetabolismInKcal': '基礎代謝(kcal)',
            'bodyCompositions.basalMetabolismLevel': '基礎代謝レベル',
            'bodyCompositions.muscleMassInGrams': '筋肉量(g)',
            'bodyCompositions.boneMassInGrams': '骨量(g)',
            'bodyCompositions.bodyAge': '体内年齢',
            'bodyCompositions.muscleScore': '筋肉スコア',
            'bodyCompositions.offalFatLevel': '内臓脂肪レベル',
            'bodyCompositions.bodyFatness': '肥満度',
            'bodyCompositions.legScore': '脚点'
          }
        }
      }
    }
  },
  mounted () {
    logger.debug(this)
    this.loadItems()
  },
  methods: {
    open (id) {
      logger.debug('open', id)
    },
    edit (id) {
      logger.debug('edit', id)
    },
    vv1000 (bc, key) {
      return NumberUtils.formatNumber(bc[key] / 1000, 1)
    },
    shortenUserId (userId) {
      return userId.match(/^ap-northeast-1:(.*)-(.*)-(.*)-(.*)$/)[1]
    },
    formatDate (time) {
      return moment(time, 'x').format('YY/MM/DD')
    },
    formatDateTime (time) {
      return moment(time, 'x').format('YY/MM/DD HH:mm')
    },
    formatCalendarTime (date) {
      return moment(date, 'x').format('YYYYMMDD000000000')
    },
    loadItems () {
      this.message = null
      this.error = null
      let params = { calendarTime: this.formatCalendarTime(this.filter.date) }
      return new Promise((resolve) => {
        setTimeout(() => {
          return this.$store.dispatch('fetchDailyEnquetes', params).then((dailyEnquetes) => {
            logger.debug('found dailyEnquetes:', dailyEnquetes)
            this.dailyEnquetes = dailyEnquetes
          }).catch(err => {
            logger.error(err)
            this.error = err.message || err
          })
        }, 1000)
      })
    },
    showDetailModal (dailyEnquete) {
      this.currentDailyEnquete = dailyEnquete
      this.$refs.userDetailModal.show()
    },
    download () {
      let csv = this.dailyEnquetes.reduce((acc, cur) => (acc && acc + '\n') + this.convertItemToCsv(cur), '')
      let dData = '\ufeff' + Object.values(this.table.csv.headings).reduce((acc, cur) => acc + ',' + cur) + '\n' + csv
      let blob = new Blob([dData], { type: 'text/csv' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Result.csv'
      link.click()
    },
    convertItemToCsv (item) {
      return Object.keys(this.table.csv.headings).reduce((acc, cur) => (acc && (acc + ',')) + (this.getV(item, cur) || ''), '')
    },
    getV (m, k) {
      if (k.indexOf('.') > 0) {
        let w = k.split('.')
        return m[w[0]] && m[w[0]][w[1]]
      }
      return m[k]
    }
  }
}
</script>

<style scoped>
.step-table, .users-table {
  font-size: 0.75rem;
}
</style>
